import { initializeApp } from "firebase/app";
import firebase from 'firebase/compat/app';
import { getDatabase} from "firebase/database";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBoPV46KDmqmsjeEUDci1uIgT_pMrfdwaI",
  authDomain: "diegosoft-f2372.firebaseapp.com",
  projectId: "diegosoft-f2372",
  storageBucket: "diegosoft-f2372.appspot.com",
  messagingSenderId: "21101727413",
  appId: "1:21101727413:web:49d10537571d0bec9338fc",
  measurementId: "G-KXSTHBY3PV"
};




  // Initialize Firebase
  //const fireDb = initializeApp(firebaseConfig);
  firebase.initializeApp(firebaseConfig);
   const fireDb = getDatabase();
   const analytics = getAnalytics();
  
  

  //const fireDb = firebase.initializeApp(firebaseConfig);

  export default fireDb